import { lightBlue } from '../palette';
import { themeVars } from '../theme/vars';
import { borderRadius } from '../tokens';
import { globalStyle, style, styleVariants } from '../layer.css';
import {
  buttonBg,
  buttonText,
  buttonBgHover,
  buttonBgActive,
} from './button.css';

export const iconButton = style({
  cursor: 'pointer',
  borderRadius: borderRadius.r8,
  border: 0,
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,

  backgroundColor: buttonBg,
  color: buttonText,

  ':hover': {
    backgroundColor: buttonBgHover,
  },
  ':active': {
    backgroundColor: buttonBgActive,
  },

  ':focus': {
    outline: 'none',
  },
  ':focus-visible': {
    outline: `2px solid ${lightBlue[500]}`,
    outlineOffset: '-1px',
  },

  ':disabled': {
    cursor: 'default',
    backgroundColor: themeVars.button.disabled.background,
    color: themeVars.button.disabled.foreground,
  },

  selectors: {
    '&[aria-pressed="true"]': {
      backgroundColor: buttonBgActive,
    },
  },
});

export const iconButtonRounded = style({
  borderRadius: '100%',
});

export const iconButtonSize = styleVariants({
  xSmall: {
    width: 24,
    height: 24,
  },
  small: {
    width: 32,
    height: 32,
  },
  medium: {
    width: 36,
    height: 36,
  },
  large: {
    width: 44,
    height: 44,
  },
});
globalStyle(`.${iconButtonSize.xSmall} :where(svg)`, {
  height: 14,
  width: 14,
});
globalStyle(`.${iconButtonSize.small} :where(svg)`, {
  height: 16,
  width: 16,
});
globalStyle(`.${iconButtonSize.medium} :where(svg)`, {
  height: 20,
  width: 20,
});
globalStyle(`.${iconButtonSize.large} :where(svg)`, {
  height: 24,
  width: 24,
});
